const advertisersActionTypes = {
  FETCH_ADVERTISERS_LIST: 'FETCH_ADVERTISERS_LIST',
  FETCH_ADVERTISERS_LIST_SUCCESS: 'FETCH_ADVERTISERS_LIST_SUCCESS',
  FETCH_ADVERTISERS_LIST_FAIL: 'FETCH_ADVERTISERS_LIST_FAIL',

  FETCH_ADD_OR_EDIT_ADVERTISER_SUBMISSION: 'FETCH_ADD_OR_EDIT_ADVERTISER_SUBMISSION',
  FETCH_ADD_OR_EDIT_ADVERTISER_SUBMISSION_SUCCESS:
    'FETCH_ADD_OR_EDIT_ADVERTISER_SUBMISSION_SUCCESS',
  FETCH_ADD_OR_EDIT_ADVERTISER_SUBMISSION_FAIL: 'FETCH_ADD_OR_EDIT_ADVERTISER_SUBMISSION_FAIL',

  SET_ADVERTISER_DETAILS: 'SET_ADVERTISER_DETAILS',
};

export default advertisersActionTypes;
